import { type ProductBySlugResponse } from '@/modules/product/aliases';
import { isEbayLander } from '@/modules/product/helpers/isEbayLander';
import { isExternalPLALander } from '@/modules/product/helpers/isExternalPLALander';
import { isSold } from '@/modules/product/helpers/isSold';

export function shouldRenderSimilarSash({
  product,
  params,
  referer,
}: {
  product?: ProductBySlugResponse;
  params: URLSearchParams;
  referer: string | null;
}) {
  const sold = product ? isSold(product.status) : false;

  return (
    sold || isEbayLander({ params }) || isExternalPLALander({ params, referer })
  );
}
